export default "__VITE_ASSET__3a173ce0__"